import { memo } from 'react';
import Grid from '@mui/material/Grid';
import MDBox from 'components/MDBox';
import Layout from './Layout';
import Header from './Header';

function EmailLayout({ children, selectedLabel }) {
    return (
        <Layout>
            <Header selectedLabel={selectedLabel} />
            <MDBox pb={3}>
                <MDBox mt={5}>
                    <Grid container spacing={3}>
                        <Grid size={12}>
                            {children}
                        </Grid>
                    </Grid>
                </MDBox>
            </MDBox>
        </Layout>
    );
}

export default memo(EmailLayout);
